(() => {
  if (window.__maHawaPerformanceFixes2026) return;
  window.__maHawaPerformanceFixes2026 = true;

  const isArabic = () => (document.documentElement.lang || '').toLowerCase().startsWith('ar');

  const addThirdPartyAccessibleNames = () => {
    document.querySelectorAll('a.wfb-field').forEach((link) => {
      const currentName = (link.getAttribute('aria-label') || link.textContent || '').trim();
      if (currentName) return;

      const href = (link.getAttribute('href') || '').toLowerCase();
      const isTelephone = href.startsWith('tel:');
      const label = isTelephone
        ? (isArabic() ? 'اتصل بماهوا' : 'Call Ma Hawa')
        : (isArabic() ? 'تواصل مع ماهوا عبر واتساب' : 'Contact Ma Hawa on WhatsApp');

      link.setAttribute('aria-label', label);
      if (!link.getAttribute('title')) link.setAttribute('title', label);
    });
  };

  const namespaceDuplicatePaymentIds = () => {
    const seen = new Map();
    document.querySelectorAll('svg[id^="pi-"]').forEach((svg) => {
      const originalId = svg.id;
      if (!originalId) return;

      const occurrence = seen.get(originalId) || 0;
      seen.set(originalId, occurrence + 1);
      if (occurrence === 0) return;

      const newId = `${originalId}-mahawa-${occurrence + 1}`;
      svg.id = newId;

      [svg, ...svg.querySelectorAll('*')].forEach((node) => {
        ['aria-labelledby', 'aria-describedby', 'href', 'xlink:href'].forEach((attribute) => {
          const value = node.getAttribute?.(attribute);
          if (!value) return;
          node.setAttribute(attribute, value.replaceAll(originalId, newId));
        });
      });
    });
  };

  const runAccessibilityFixes = () => {
    addThirdPartyAccessibleNames();
    namespaceDuplicatePaymentIds();
  };

  const scheduleAccessibilityFixes = () => {
    [0, 400, 1200, 2600].forEach((delay) => window.setTimeout(runAccessibilityFixes, delay));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleAccessibilityFixes, { once: true });
  } else {
    scheduleAccessibilityFixes();
  }

  window.addEventListener('load', scheduleAccessibilityFixes, { once: true });
  document.addEventListener('shopify:section:load', scheduleAccessibilityFixes);
})();
